import { render } from "./softwareProductOverview.vue?vue&type=template&id=7bc4d906&scoped=true&ts=true"
import script from "./softwareProductOverview.vue?vue&type=script&lang=ts"
export * from "./softwareProductOverview.vue?vue&type=script&lang=ts"

import "./softwareProductOverview.vue?vue&type=style&index=0&id=7bc4d906&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc4d906"]])

export default __exports__